import React from "react";
import ReactDOM from "react-dom/client";
import reportWebVitals from "./reportWebVitals";
import Routes from "./routes";
import TestEnvironmentLabel from "./components/TestEnvironmentLabel";

import "./index.css";

import "./styles/globalStyles.scss";
import "./styles/pages/ContactsPage.scss";
import "./styles/pages/LoginPage.scss";
import "./styles/pages/RecoveryPasswordPage.scss";
import "./styles/pages/RegisterPage.scss";
import "./styles/pages/RemittancesAndDepositsPage.scss";
import "./styles/pages/StatementPage.scss";
import "./styles/pages/TransactionPage.scss";
import "./styles/pages/UserPage.scss";
import "./styles/pages/SubUsersPage.scss";
import "./styles/pages/SwapPage.scss";

import "./styles/components/PixTransfer.scss";
import "./styles/components/AccountInfo.scss";
import "./styles/components/CoinQuote.scss";
import "./styles/components/CoinQuotesBar.scss";
import "./styles/components/Footer.scss";
import "./styles/components/LastTransactions.scss";
import "./styles/components/SideMenu.scss";
import "./styles/components/Balance.scss";
import "./styles/components/ToggleButton.scss";
import "./styles/components/SlideOver.scss";
import "./styles/components/Table.scss";

const themes = {
  zicredit: {
    primary: "#FFCC00",
    secondary: "#061B2B",
    tertiary: "#0F1824",
  },
  default: {
    primary: "#1c787e",
    secondary: "#061B2B",
    tertiary: "#0F1824",
  },
};

const hostname = window.location.hostname;

let theme;
if (hostname.includes("zicredit.com")) {
  theme = themes.zicredit;
} else {
  theme = themes.default;
}

document.documentElement.style.setProperty("--primary", theme.primary);
document.documentElement.style.setProperty("--secondary", theme.secondary);
document.documentElement.style.setProperty("--tertiary", theme.tertiary);

const Root = () => (
  <>
    <Routes />
    <TestEnvironmentLabel />
  </>
);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<Root />);
reportWebVitals();
